import { getType } from 'typesafe-actions';
import { AnnotationSaveEvent } from '../models/annotation-save-event.model';
import { AnnotationResource } from '../resources/annotation.resource';
import { AnnotationRelationResource } from '../resources/annotation-relation.resource';
import {
  Granularity,
  clearCompareAnnotations,
  clearVersionHistory,
  fetchVersionHistory,
  fetchVersionHistoryError,
  fetchVersionHistorySuccess,
  selectVersion,
  setCompareAnnotations,
  setGranularity,
  toggleDiffFilter,
  toggleDiffMode,
} from '../actions/version-history.actions';

export type CompareState =
  | { status: 'idle' }
  | { status: 'loading' }
  | {
      status: 'loaded';
      annotations: AnnotationResource[];
      relations: AnnotationRelationResource[];
      saveEvent: AnnotationSaveEvent;
    }
  | { status: 'unavailable' };

export type VersionHistoryState = {
  saveEvents: AnnotationSaveEvent[];
  loading: boolean;
  error: string | null;
  diffModeEnabled: boolean;
  diffFilterActive: boolean;
  granularity: Granularity;
  selectedSaveEventId: number | null;
  compare: CompareState;
};

const defaultState: VersionHistoryState = {
  saveEvents: [],
  loading: false,
  error: null,
  diffModeEnabled: false,
  diffFilterActive: false,
  granularity: 'all',
  selectedSaveEventId: null,
  compare: { status: 'idle' },
};

export function versionHistoryReducer(
  state: VersionHistoryState = defaultState,
  action: any,
): VersionHistoryState {
  switch (action.type) {
    case getType(fetchVersionHistory):
      return { ...state, loading: true, error: null };

    case getType(fetchVersionHistorySuccess):
      return {
        ...state,
        saveEvents: action.payload.saveEvents,
        loading: false,
        compare: state.diffModeEnabled ? { status: 'loading' } : state.compare,
      };

    case getType(fetchVersionHistoryError):
      return { ...state, loading: false, error: action.payload.error };

    case getType(selectVersion):
      return {
        ...state,
        selectedSaveEventId: action.payload.saveEventId,
        compare: state.diffModeEnabled
          ? { status: 'loading' }
          : { status: 'idle' },
      };

    case getType(setCompareAnnotations):
      return {
        ...state,
        compare: {
          status: 'loaded',
          saveEvent: action.payload.saveEvent,
          annotations: action.payload.annotations,
          relations: action.payload.relations,
        },
      };

    case getType(clearCompareAnnotations):
      return {
        ...state,
        compare: { status: 'unavailable' },
      };

    case getType(toggleDiffMode):
      return {
        ...state,
        diffModeEnabled: action.payload.enabled,
        diffFilterActive: false,
        granularity: action.payload.enabled ? state.granularity : 'all',
        compare: action.payload.enabled
          ? { status: 'loading' }
          : { status: 'idle' },
      };

    case getType(setGranularity):
      return {
        ...state,
        granularity: action.payload.granularity,
        compare: state.diffModeEnabled ? { status: 'loading' } : state.compare,
      };

    case getType(toggleDiffFilter):
      return { ...state, diffFilterActive: !state.diffFilterActive };

    case getType(clearVersionHistory):
      return defaultState;

    default:
      return state;
  }
}
